// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__5Ukr6","row":"Node_row__vi-u1","label":"Node_label__3qZ1O","footer":"Node_footer__2iGsQ"};